import React from 'react';
import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="py-20 bg-blue-600 text-white">
      <div className="container mx-auto px-4 max-w-4xl text-center">
        <h2 className="text-4xl font-bold mb-6">
          帮助提升您的求职竞争力
        </h2>
        <p className="text-xl mb-8 opacity-90">
          立即注册，体验专业的简历匹配度评估服务，优化简历，提升获得面试的机会
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/register"
            className="bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors"
          >
            免费注册
          </Link>
          <Link
            to="/login"
            className="bg-transparent text-white px-8 py-3 rounded-lg font-semibold border border-white hover:bg-white hover:text-blue-600 transition-colors"
          >
            已有账户？登录
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTASection;